import { DomainEntities, IdentityFieldValues } from '@/pages/UserAccount/Profile';

import { YesNoSelectOptions } from '@/features/ui/ProfileChapters';

import { IntegrationSystem } from '@/shared/types';

import { profileDocumentDataInfoFieldsMapper } from '@/components/Forms/DocumentsData';

import { AuthContextInterface } from '@/contexts/Auth/AuthContext';

import { DocumentTypeEntity, DocumentTypeCode } from '@/api/types';

const defaultValues: IdentityFieldValues = {
  // Громадянство
  withoutCitizenship: null,
  citizenship: null,

  // Документ, що посвідчує особу (паспорт)
  passport: undefined,
  passportDocTypeCode: undefined,
  isWithoutCitizenshipUnset: true,

  rnokpp: '',

  documents: {
    passport: {
      info: {},
      type: null,
    },
  },
};

export const buildIdentityCardDefaultValues = (
  authContext: AuthContextInterface,
  domainEntities: Partial<Pick<DomainEntities, 'optionsCountry' | 'passportDocumentTypeEntities'>>,
): IdentityFieldValues => {
  const passport =
    (domainEntities.passportDocumentTypeEntities as Array<DocumentTypeEntity<IntegrationSystem.ERZ>>)?.find(
      ({ code }) => code === authContext.documentsData['passport']?.type,
    ) ?? null;

  const isWithoutCitizenshipUnset = authContext.userData?.citizenship === null;
  const withoutCitizenship = authContext.userData?.citizenship?.id === null;

  const citizenship =
    domainEntities.optionsCountry?.find(({ id }) => id === authContext.userData?.citizenship?.id) ?? undefined;

  function toDocumentTypeEntity(
    code: DocumentTypeCode | 'null' | null | undefined,
  ): DocumentTypeEntity<IntegrationSystem.ERZ>['code'] | null {
    if (!code || code === 'null') return null;
    // if DocumentTypeEntity – its object with field code, make this way:
    return code as DocumentTypeEntity<IntegrationSystem.ERZ>['code'];
  }

  const documents = Object.entries(authContext.documentsData).reduce<IdentityFieldValues['documents']>(
    (acc, [key, value]) => {
      if (key === 'passport') {
        return {
          ...acc,
          [key]: {
            info: { ...profileDocumentDataInfoFieldsMapper(value?.fields) },
            type: toDocumentTypeEntity(passport?.code),
          },
        };
      }

      return {
        ...acc,
      };
    },
    defaultValues.documents,
  );

  return {
    ...defaultValues,
    documents,
    citizenship: isWithoutCitizenshipUnset || withoutCitizenship ? null : citizenship,
    passport,
    passportDocTypeCode: passport?.code,
    isWithoutCitizenshipUnset: !!isWithoutCitizenshipUnset,
    withoutCitizenship: isWithoutCitizenshipUnset
      ? null
      : withoutCitizenship
        ? YesNoSelectOptions.YES
        : YesNoSelectOptions.NO,
    rnokpp: authContext?.userData?.drfo_code ?? '',
  };
};
